import { render, staticRenderFns } from "./Archiv.vue?vue&type=template&id=8c27fe72&scoped=true&"
import script from "./Archiv.vue?vue&type=script&lang=js&"
export * from "./Archiv.vue?vue&type=script&lang=js&"
import style0 from "./Archiv.vue?vue&type=style&index=0&id=8c27fe72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c27fe72",
  null
  
)

export default component.exports